"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  table: {
    padding: "0",
    direction: "rtl"
  },
  tableHeader: {
    fontFamily: "IranSansX",
    backgroundColor: _variables.colors.swan,
    fontSize: "14px",
    padding: "20px 50px 20px 50px",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
    color: _variables.colors.wolf,
    minWidth: "50px"
  },
  li: function li(props) {
    return {
      paddingTop: props.size === "sm" ? "9px" : "20px",
      paddingRight: props.size === "sm" ? "12px" : "20px",
      paddingBottom: props.size === "sm" ? "9px" : "20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "-webkit-fill-available",
      "& div": {
        fontSize: props.size === "sm" ? "12px" : "14px"
      }
    };
  },
  tableRow: {
    backgroundColor: _variables.colors.ghost,
    border: "1px solid ".concat(_variables.colors.hare),
    cursor: "pointer",
    fontFamily: "IranSansX",
    borderRadius: "10px",
    // padding: "20px 20px",
    height: "auto",
    display: "flex",
    margin: "10px 30px",
    fontSize: "14px",
    color: _variables.colors.wolf,
    alignItems: "center"
  },
  listSelected: {
    color: "".concat(_variables.colors.father, "!important"),
    backgroundColor: "".concat(_variables.colors.swan, "!important"),
    border: "1px solid ".concat(_variables.colors.father, "!important")
  },
  tableBody: {
    display: 'flex',
    flexDirection: 'column'
  },
  col: {
    // flexBasis: "0",
    flexGrow: "1",
    maxWidth: "100%",
    minWidth: "50px",
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  col4: {
    flex: "0 0 33.333333%",
    maxWidth: "33.333333%"
  },
  cardRow: {
    display: "flex",
    flexWrap: "wrap",
    direction: "rtl"
  },
  card: {
    fontFamily: "IranSansX",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    backgroundClip: "border-box",
    backgroundColor: _variables.colors.ghost,
    border: "1px solid ".concat(_variables.colors.swan),
    borderRadius: "10px",
    marginRight: "15px",
    marginLeft: "15px",
    marginBottom: "30px",
    color: _variables.colors.wolf,
    cursor: "pointer"
  },
  cardHeader: {
    padding: "25px 29px 21px 27px",
    marginBottom: "0",
    borderBottom: "1px solid ".concat(_variables.colors.swan),
    fontSize: "14px",
    display: "flex",
    justifyContent: "space-between"
  },
  cardBody: {
    flex: "1 1 auto",
    padding: "30px",
    fontSize: "14px"
  },
  cardText: {
    marginBottom: "22px",
    marginTop: "0",
    "&:last-child": {
      marginRight: "0",
      marginBottom: "0"
    }
  },
  left: {
    direction: "ltr",
    flex: "1 1 auto",
    padding: "0 30px 0 30px",
    fontSize: "14px",
    "&:last-child": {
      paddingBottom: "30px !important"
    }
  },
  gridSelected: {
    "& $card": {
      color: "".concat(_variables.colors.father, " !important"),
      backgroundColor: "".concat(_variables.colors.swan, " !important"),
      border: "1px solid ".concat(_variables.colors.father, " !important")
    },
    "& $cardHeader": {
      borderBottom: "1px solid ".concat(_variables.colors.father)
    }
  },
  newGrid: {
    height: "calc(100% - 30px)",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    backgroundColor: _variables.colors.swan,
    border: "1px dashed ".concat(_variables.colors.hare),
    borderRadius: "10px",
    marginBottom: "30px",
    marginLeft: "15px",
    marginRight: "15px"
  },
  newList: {
    backgroundColor: _variables.colors.swan,
    border: "1px dashed ".concat(_variables.colors.hare),
    height: "auto",
    margin: "10px 30px",
    display: "flex",
    padding: "15px 0px",
    alignItems: "center",
    borderRadius: "10px",
    justifyContent: "center"
  },
  action: function action(props) {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      minWidth: "fit-content",
      paddingTop: props.size === "sm" ? "9px" : "20px",
      paddingLeft: props.size === "sm" ? "12px" : "20px",
      paddingBottom: props.size === "sm" ? "9px" : "20px",
      "& div": {
        fontSize: props.size === "sm" ? "12px" : "14px"
      }
    };
  }
}), {
  name: 'pds-table'
});
exports.useStyles = useStyles;